// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loading-spinner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
`, "",{"version":3,"sources":["webpack://./views/components/Loading.vue"],"names":[],"mappings":";AAqCA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;AAChB;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC","sourcesContent":["<template>\n  <div v-if=\"isLoading\" id=\"hora-loading\" style=\"direction: rtl\" class=\"loading\">\n    <HoraLogo\n      style=\"margin-top: 12rem\"\n      :with_text=\"false\"\n      :animated=\"true\"\n      :is_loading=\"true\"\n    ></HoraLogo>\n  </div>\n</template>\n\n<script>\nimport HoraLogo from \"../components/HoraLogo.vue\";\n\nexport default {\n  name: \"Loading\",\n  props: {\n    isLoading: {\n      type: Boolean,\n      default: false\n    }\n  },\n  components: {\n    HoraLogo,\n  },\n  methods: {\n    showLoading() {\n      this.isLoading = true;\n    },\n    hideLoading() {\n      this.isLoading = false;\n    },\n  },\n};\n</script>\n\n<style>\n.loading-spinner {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n}\n\n.loading {\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n  background: rgba(255, 255, 255, 0.8);\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
